import { render, staticRenderFns } from "./CoolingChamber.vue?vue&type=template&id=d79245b8"
import script from "./CoolingChamber.vue?vue&type=script&lang=js"
export * from "./CoolingChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports